/**
 * Catalogo predefinito degli attributi, per famiglia.
 *
 * I 32 nomi sono quelli della tassonomia (docs/sviluppi/gestione-carichi).
 * Valgono per tutti i ruoli: un portiere può allenare il tiro, un attaccante
 * la parata. Seed SQL, test e UI importano da qui, così non divergono.
 */

export const FAMIGLIE_ATTRIBUTO = ['fisici', 'tecnici', 'mentali', 'portiere'] as const;
export type FamigliaAttributo = (typeof FAMIGLIE_ATTRIBUTO)[number];

export const ETICHETTA_FAMIGLIA_ATTRIBUTO: Record<FamigliaAttributo, string> = {
  fisici: 'Fisici',
  tecnici: 'Tecnici',
  mentali: 'Mentali',
  portiere: 'Portiere',
};

export interface AttributoPredefinito {
  nome: string;
  famiglia: FamigliaAttributo;
}

export const ATTRIBUTI_PREDEFINITI: readonly AttributoPredefinito[] = [
  { nome: 'Velocità', famiglia: 'fisici' },
  { nome: 'Accelerazione', famiglia: 'fisici' },
  { nome: 'Resistenza', famiglia: 'fisici' },
  { nome: 'Forza', famiglia: 'fisici' },
  { nome: 'Agilità', famiglia: 'fisici' },
  { nome: 'Equilibrio', famiglia: 'fisici' },
  { nome: 'Reattività', famiglia: 'fisici' },
  { nome: 'Elevazione', famiglia: 'fisici' },
  { nome: 'Tiro', famiglia: 'tecnici' },
  { nome: 'Passaggio', famiglia: 'tecnici' },
  { nome: 'Cambio gioco', famiglia: 'tecnici' },
  { nome: 'Cross', famiglia: 'tecnici' },
  { nome: 'Dribbling', famiglia: 'tecnici' },
  { nome: 'Controllo palla', famiglia: 'tecnici' },
  { nome: 'Colpo di testa', famiglia: 'tecnici' },
  { nome: 'Marcatura', famiglia: 'tecnici' },
  { nome: 'Contrasto', famiglia: 'tecnici' },
  { nome: 'Interdizione', famiglia: 'tecnici' },
  { nome: 'Visione di gioco', famiglia: 'mentali' },
  { nome: 'Intelligenza tattica', famiglia: 'mentali' },
  { nome: 'Determinazione', famiglia: 'mentali' },
  { nome: 'Leadership', famiglia: 'mentali' },
  { nome: 'Freddezza', famiglia: 'mentali' },
  { nome: 'Concentrazione', famiglia: 'mentali' },
  { nome: 'Collaborazione', famiglia: 'mentali' },
  { nome: 'Coraggio', famiglia: 'mentali' },
  { nome: 'Parata', famiglia: 'portiere' },
  { nome: 'Uscita alta', famiglia: 'portiere' },
  { nome: '1v1', famiglia: 'portiere' },
  { nome: 'Gioco coi piedi', famiglia: 'portiere' },
  { nome: 'Rilancio', famiglia: 'portiere' },
  { nome: "Comando dell'area", famiglia: 'portiere' },
];
